// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"93116450","642":"f120bd60"}[chunkId] + ".chunk.js";
};